import apiClient, { formatApiError } from "./client";

/**
 * Password Manager API Service
 * Handles all API calls related to password database management
 * Base endpoint: /api/passwortdatenbank
 */

export const getPasswordManagerStatus = async (oid) => {
  try {
    const response = await apiClient.get(`/api/passwortdatenbank/status/${oid}`);
    return response.data;
  } catch (error) {
    console.error("getPasswordManagerStatus error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Laden des Passwortverwaltungsstatus") };
  }
};

export const activatePasswordManager = async (dto) => {
  try {
    const response = await apiClient.post("/api/passwortdatenbank/aktivieren", dto);
    return response.data;
  } catch (error) {
    console.error("activatePasswordManager error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Aktivieren der Passwortdatenbank") };
  }
};

export const deactivatePasswordManager = async (oid) => {
  try {
    const response = await apiClient.post(`/api/passwortdatenbank/deaktivieren/${oid}`);
    return response.data;
  } catch (error) {
    console.error("deactivatePasswordManager error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Deaktivieren der Passwortdatenbank") };
  }
};

export const updateEmail = async (oid, email) => {
  try {
    const response = await apiClient.put(`/api/passwortdatenbank/email/${oid}`, { email });
    return response.data;
  } catch (error) {
    console.error("updateEmail error:", error);
    return { success: false, data: null, message: formatApiError(error, "Fehler beim Aktualisieren der E-Mail-Adresse") };
  }
};
